require('./bootstrap');

require('bootstrap-select');

import ConfirmButton from './components/ConfirmButton.js';

$(document).ready( function(){
    $("#logoutBtn").on('click', function(event){
        event.preventDefault();
        $("#logout-form").submit();
    });
    $("#contactBtn").on('click', function(){
        $(".contact-modal").modal();
    });


    $(".filterInput").on('change',function(){
       $("#filterForm").submit();
    });

    $(".btn-confirm").each(function () {
        var comp = new ConfirmButton($(this));
    });

    setTimeout(function(){

        var maxHeight = 0;
        $(".course .summary").each(function(){
            maxHeight = Math.max($(this).outerHeight(),maxHeight);
        });

        $(".course .summary").css({'min-height': maxHeight});
    },50);

    let pictureSetCounter = 0;

    // When the "Add Creator" button is clicked
    $('#add-picture-set').on('click', function() {
        // Get the index of the last picture set
        let lastPictureSetIndex = $('#pictures-container .picture-set:last').data('index');
            
        // Increment the picture set counter
        pictureSetCounter = lastPictureSetIndex + 1;
    
        // Clone the first picture set and append it to the container
        let clonedSet = $('#pictures-container .picture-set:first').clone();
        clonedSet.find('input[name="creators['+ lastPictureSetIndex +'][picture]"]').attr('name', 'creators[' + pictureSetCounter + '][picture]');
        clonedSet.find('input[name="creators['+ lastPictureSetIndex +'][name]"]').attr('name', 'creators[' + pictureSetCounter + '][name]');
        clonedSet.find('input[name="creators['+ lastPictureSetIndex +'][title]"]').attr('name', 'creators[' + pictureSetCounter + '][title]');
        clonedSet.appendTo('#pictures-container');
    
        // Reset the input values in the new picture set
        $('#pictures-container .picture-set:last input').val('');
    });
});
